import { LabelType } from "types/enums.ts";
import { z } from "zod";

export const schema = z.object({
    name: z.string().min(1, "forms.general-validation.required"),
    type: z.nativeEnum(LabelType),
    country_id: z.number(),
    color: z.string().nullable().optional(),
});

export type LabelFormData = z.infer<typeof schema>;
